import { render, staticRenderFns } from "./GH.vue?vue&type=template&id=67ca6eac&scoped=true"
import script from "./GH.vue?vue&type=script&lang=js"
export * from "./GH.vue?vue&type=script&lang=js"
import style0 from "./GH.vue?vue&type=style&index=0&id=67ca6eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ca6eac",
  null
  
)

export default component.exports